<template>
  <v-footer
    id="home-footer"
    color="grey darken-4"
    dark
    min-height="72"
  >
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <div
            class="d-flex flex-wrap justify-md-start justify-center justify-md-none"
          >
            <template v-for="(s, i) in social">
              <a
                v-if="s.icon"
                :key="s.text"
                class="white--text pa-1 pa-md-0"
                :href="s.link"
                target="_blank"
              ><v-icon :color="highlightcontrast">{{ s.icon }}</v-icon></a>
              <a
                v-else
                :key="s.text"
                class="white--text pa-1 pa-md-0"
                :href="s.link"
                target="_blank"
                v-text="s.text"
              />

              <v-responsive
                v-if="i < social.length"
                :key="`divider-${s}`"
                class="mx-4 shrink hidden-sm-and-down"
                max-height="24"
              >
                <v-divider vertical />
              </v-responsive>
            </template>
            <a
              key="Impressum"
              class="white--text pa-1 pa-md-0"
              @click="navigateImpressum"
              v-text="'Impressum'"
            />
          </div>
        </v-col>

        <v-col
          class="text-center text-md-right"
          cols="12"
          md="6"
        >
          &copy; 2023 IFEA Treuhand GmbH
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'HomeFooter',

    data: () => ({
      social: [
        { text: 'Facebook', link: 'https://www.facebook.com/IFEA.TREUHAND', icon: 'mdi-facebook' },
        { text: 'Instagram', link: 'https://www.instagram.com/ifea.treuhand/', icon: 'mdi-instagram' },
        { text: 'LinkedIn', link: 'https://www.linkedin.com/company/ifea-treuhand-gmbh/', icon: 'mdi-linkedin' },
        { text: 'Datenschutzerklärung', link: './assets/Files/IFEADatenschutzerklärung092023.pdf' },
      ],
    }),
    methods: {
      navigateImpressum () {
        if (this.$route.path !== '/impressum') {
          this.$router.push('/impressum')
        }
      },
    },
  }
</script>

<style lang="sass">
#home-footer a
  text-decoration: none
</style>
